export default "__VITE_ASSET__BJJ_T_f5__"